module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-report-3.a6453bed.svg";